import styles from './TextArea.module.scss';

import type { FC, ChangeEventHandler } from 'react';

import { assertNever } from '@/packages/nurse-senka-frontend-sdk';

type Props = {
  id: string;
  width: 'default' | 'wide';
  placeholder?: string;
  onChange?: ChangeEventHandler<HTMLTextAreaElement>;
  defaultValue?: string;
};

export const TextArea: FC<Props> = ({
  id,
  width,
  placeholder,
  onChange,
  defaultValue,
}) => {
  switch (width) {
    case 'default':
      return (
        <textarea
          id={id}
          className={styles['textarea-default']}
          placeholder={placeholder}
          onChange={onChange}
          defaultValue={defaultValue}
        />
      );
    case 'wide':
      return (
        <textarea
          id={id}
          className={styles['textarea-wide']}
          placeholder={placeholder}
          onChange={onChange}
          defaultValue={defaultValue}
        />
      );
    default:
      return assertNever(width);
  }
};
